import { resolveCardImageSource } from "@/constants/cardAssets"
import { CardShapeLayout } from "./cardShapeLayout"

const STRIP_PILL_BG = "#2D2930"

function PillIcon({
  source,
  size,
}: {
  source?: string | null
  size: number
}) {
  const resolved = resolveCardImageSource(source)
  if (!resolved) return null
  return (
    <img
      src={resolved}
      alt=""
      width={size}
      height={size}
      className="rounded-full object-cover"
    />
  )
}

interface CardInfoStripProps {
  layout: CardShapeLayout
  combatPower: number
  elementIcon?: string | null
  styleIcon?: string | null
  powerIcon?: string | null
}

export default function CardInfoStrip({
  layout,
  combatPower,
  elementIcon,
  styleIcon,
  powerIcon,
}: CardInfoStripProps) {
  const iconSize = layout.pillHeight * 0.74
  const iconGap = 14 * layout.scale
  const iconsPillRadius = layout.pillHeight / 2
  const powerPillRadius = layout.pillHeight / 2
  const pillPaddingH = 6 * layout.scale
  const powerPaddingH = 7 * layout.scale
  const powerGap = 6 * layout.scale
  const powerFontSize = 18 * layout.scale
  const powerCornerRadius = 8 * layout.scale

  return (
    <div
      className="pointer-events-none absolute left-0 z-[4]"
      style={{
        top: layout.stripStart,
        height: layout.stripH,
        width: layout.innerW,
      }}
    >
      <div
        className="absolute flex flex-row items-center justify-center shadow-md"
        style={{
          top: layout.stripIconsTop - layout.stripStart,
          right: 0,
          width: layout.iconsPillWidth,
          height: layout.pillHeight,
          borderTopLeftRadius: iconsPillRadius,
          borderTopRightRadius: iconsPillRadius,
          borderBottomRightRadius: iconsPillRadius,
          borderBottomLeftRadius: 0,
          paddingLeft: pillPaddingH,
          paddingRight: pillPaddingH,
          gap: iconGap,
          backgroundColor: STRIP_PILL_BG,
        }}
      >
        <PillIcon source={elementIcon} size={iconSize} />
        <PillIcon source={styleIcon} size={iconSize} />
      </div>

      <div
        className="absolute flex flex-row items-center shadow-md"
        style={{
          top: layout.stripPowerTop - layout.stripStart,
          left: 0,
          width: layout.powerPillWidth,
          height: layout.pillHeight,
          borderTopLeftRadius: powerPillRadius,
          borderTopRightRadius: powerCornerRadius,
          borderBottomRightRadius: powerPillRadius,
          borderBottomLeftRadius: powerPillRadius,
          paddingLeft: powerPaddingH,
          paddingRight: powerPaddingH,
          gap: powerGap,
          backgroundColor: STRIP_PILL_BG,
        }}
      >
        <PillIcon source={powerIcon} size={iconSize} />
        <span
          className="font-medium text-[#F3E8FF]"
          style={{ fontSize: powerFontSize, letterSpacing: 0.2 }}
        >
          {combatPower}
        </span>
      </div>
    </div>
  )
}
